import { useLocation } from "react-router-dom";
import { useEffect } from "react";


function ScrollFix() {
  const location = useLocation();

  useEffect(() => {
    document.body.style.overflowY = "auto";
    document.body.style.paddingRight = "0px";

    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

export default ScrollFix;